
import pdfImg from "../assets/pdf.jpg";

const PdfPage = ({ qrData }) => {
  return (
    <div className="main_body">
      <div className="main_heading">PDF By</div>
      <div className="sub_heading">
        {qrData?.first_name || ""} {qrData?.last_name || ""}
      </div>
      <div
        className="pdf_container"
        onClick={() => {
          window.open(
            qrData?.pdf ||
              ""
          );
        }}
      >
        <img src={pdfImg} alt="PDF" className="pdf_image" />
      </div>
    </div>
  );
};

export default PdfPage;
